import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from './ClientInvestments.module.css'
import Modal from '../../components/Modal/Modal'
import { prpHttpAPI } from '../../services/prpHttpAPI'
export const ClientInvestments = () => {
  const navigate = useNavigate()
  // token authentication 
  const checkToken = (e) => {

    const localtoken = localStorage.getItem("ssotoken");
    // const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const ssotoken = queryParams.get('ssotoken');
    if (localtoken) {
      console.log('User logged in');
    }
    else {
      console.log('token not found');
      // Redirect to a different URL
      window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`;

      //  navigate('');
    }
  }
  useEffect(()=>{
    checkToken();
  },[])
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    epfHolding: "",
    epfContribution: "",
    npsHolding: "",
    npsContribution: "",
    mfHolding: "",
    mfContribution: "",
    bondsHolding: "",
    bondsContribution: "",
    nonRetHolding: "",
    nonRetContribution: "",
    ppfHolding: "",
    ppfContribution: "",
    retHolding: "",
    retContribution: "",
    stocksHolding: "",
    stocksContribution: "",
    fdHolding: "",
    fdContribution: "",
    totalHolding: "",
    totalContribution: ""
  })
  const [url, setUrl] = useState('')
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [epfHolding, setEpfHolding] = useState("")
  const [numericEpfHolding, setNumericEpfHolding] = useState(null);
  const [epfContribution, setEpfContribution] = useState("")
  const [numericEpfContribution, setNumericEpfContribution] = useState(null)
  const [npsHolding, setNpsHolding] = useState("")
  const [numericNpsHolding, setNumericNpsHolding] = useState(null)
  const [npsContribution, setNpsContribution] = useState("")
  const [numericNpsContribution, setNumericNpsContribution] = useState(null)
  const [mfHolding, setMfHolding] = useState("")
  const [numericMfHolding, setNumericMfHolding] = useState(null)

  const [mfContribution, setMfContribution] = useState("")
  const [numericMfContribution, setNumericMfContribution] = useState(null)
  const [bondsHolding, setBondsHolding] = useState("")
  const [numericBondsHolding, setNumericBondsHolding] = useState(null)

  const [bondsContribution, setBondsContribution] = useState("0")
  const [numericBondsContribution, setNumericBondsContribution] = useState(null)

  const [nonRetHolding, setNonRetHolding] = useState("")
  const [numericNonRetHolding, setNumericNonRetHolding] = useState(null)

  const [nonRetContribution, setNonRetContribution] = useState("")
  const [numericNonRetContribution, setNumericNonRetContribution] = useState(null)

  const [ppfHolding, setPpfHolding] = useState("")
  const [numericPpfHolding, setNumericPpfHolding] = useState(null)

  const [ppfContribution, setPpfContribution] = useState("")
  const [numericPpfContribution, setNumericPpfContribution] = useState(null)

  const [retHolding, setRetHolding] = useState("")
  const [numericRetHolding, setNumericRetHolding] = useState(null)

  const [retContribution, setRetContribution] = useState("")
  const [numericRetContribution, setNumericRetContribution] = useState(null)

  const [stocksHolding, setStocksHolding] = useState("")
  const [numericStocksHolding, setNumericStocksHolding] = useState(null)

  const [stocksContribution, setStocksContribution] = useState("0")
  const [numericStocksContribution, setNumericStocksContribution] = useState(null)

  const [fdHolding, setFdHolding] = useState("")
  const [numericFdHolding, setNumericFdHolding] = useState(null)

  const [fdContribution, setFdContribution] = useState("")
  const [numericFdContribution, setNumericFdContribution] = useState(null)

  const [totalHolding, setTotalHolding] = useState("")
  const [totalContribution, setTotalContribution] = useState("")
  const [progressValuePre, setProgressValuePre] = useState(6);
  const inflationRateClientDetails = JSON.parse(localStorage.getItem('inflationRate'));
  //const [progressValuePost, setProgressValuePost] = useState(inflationRateClientDetails?inflationRateClientDetails:0);
  const [progressValuePost, setProgressValuePost] = useState(inflationRateClientDetails?4:4);
  const [showModal, setShowModal] = useState(false)
  const location = useLocation();
  const plan_id = localStorage.getItem("plan_id");
  const pdfData = {
    plan_id: plan_id
  }


   //onRefreshOnly
   useEffect(() => {
    const handleRefresh = () => {
          localStorage.removeItem('clientInvestmentData');

    };
  
    window.addEventListener('beforeunload', handleRefresh);
  
    return () => {
      window.removeEventListener('beforeunload', handleRefresh);
    };
  }, []);
  //toRetainClientDetails - on clicking back button in clientInvestments
   useEffect(() => {
    const savedData = localStorage.getItem('clientInvestmentData');
    if (savedData) {
      const userData = JSON.parse(savedData);
      setEpfHolding(numToString(userData.epf_holding));
      setNumericEpfHolding(userData.epf_holding)
      setEpfContribution(numToString(userData.epf_monthly));
      setNumericEpfContribution(userData.epf_monthly)

      setPpfHolding(numToString(userData.ppf_holding))
      setPpfContribution(numToString(userData.ppf_monthly))
      setNpsHolding(numToString(userData.nps_holding))
      setNpsContribution(numToString(userData.nps_monthly))
      setRetHolding(numToString(userData.other_retirement_investment_holding))
      setRetContribution(numToString(userData.other_retirement_investment_monthly));
      setNonRetHolding(numToString(userData.other_non_retirement_investment_holding))
      setNonRetContribution(numToString(userData.other_non_retirement_investment_monthly))
      setMfHolding(numToString(userData.mf_holding))
      setMfContribution(numToString(userData.mf_monthly))
      setStocksHolding(numToString(userData.stocks_holding))
      setBondsHolding(numToString(userData.bonds_holding))
      setFdHolding(numToString(userData.fdrd_holding))
      setFdContribution(numToString(userData.fdrd_monthly))

      //
      setNumericPpfHolding((userData.ppf_holding))
      setNumericPpfContribution((userData.ppf_monthly))
      setNumericNpsHolding((userData.nps_holding))
      setNumericNpsContribution((userData.nps_monthly))
      setNumericRetHolding((userData.other_retirement_investment_holding))
      setNumericRetContribution((userData.other_retirement_investment_monthly));
      setNumericNonRetHolding((userData.other_non_retirement_investment_holding))
      setNumericNonRetContribution((userData.other_non_retirement_investment_monthly))
      setNumericMfHolding((userData.mf_holding))
      setNumericMfContribution((userData.mf_monthly))
      setNumericStocksHolding((userData.stocks_holding))
      setNumericBondsHolding((userData.bonds_holding))
      setNumericFdHolding((userData.fdrd_holding))
      setNumericFdContribution((userData.fdrd_monthly))
      //
      setProgressValuePre((userData.pre_ret_ror))
      setProgressValuePost((userData.post_ret_ror))
      console.log("total,", userData.total_holding);
      setTotalHolding(numToString(userData.total_holding))
      setTotalContribution(numToString(userData.total_monthly))
      console.log("totalll", totalHolding);

    }
  }, []);
  //function to convert comma separated to numeric
  const stringToNum =(val)=>{
    let inputValue = val.replace(/,/g, "");
    return Number(inputValue)
  }
  //function to convert num to string 
  const numToString =(val)=>{
    if(val==0){
      return ""
    }
    return Intl.NumberFormat("en-IN").format(val)
  }
  //fetching version from plan_id
  const processString = (str) => {
    if (str.length === 10) {
      return 1;
    } else if (str.length > 10) {
      const parts = str.split('_');
      return parts.length > 1 ? Number(parts[1]) : null; // Return the number after '_', if present
    }
    return null; // Handle cases where string length is less than 10
  };
  // disable scrolling when modal is visible
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup in case of component unmount
    };
  }, [showModal]);
  //totalHolding
  useEffect(() => {
    const totalHold = Number(numericEpfHolding || 0) + Number(numericNpsHolding || 0) + Number(numericMfHolding || 0) + Number(numericPpfHolding || 0) + Number(numericFdHolding || 0) + Number(numericRetHolding || 0) + Number(numericNonRetHolding || 0) + Number(numericBondsHolding || 0) + Number(numericStocksHolding || 0)
    setTotalHolding(Intl.NumberFormat("en-IN").format(totalHold));
  }, [numericEpfHolding, numericNpsHolding, numericMfHolding, numericPpfHolding, numericFdHolding, numericRetHolding, numericNonRetHolding, numericBondsHolding, numericStocksHolding])
  //totalContribution
  useEffect(() => {
    const total = Number(numericEpfContribution) + Number(numericNpsContribution) + Number(numericMfContribution) + Number(numericPpfContribution) + Number(numericFdContribution) + Number(numericRetContribution) + Number(numericNonRetContribution) + Number(numericBondsContribution) + Number(numericStocksContribution)
    setTotalContribution(Intl.NumberFormat("en-IN").format(total));
  }, [numericEpfContribution, numericNpsContribution, numericMfContribution, numericPpfContribution, numericFdContribution, numericRetContribution, numericNonRetContribution, numericBondsContribution, numericStocksContribution])

  const handleProgressPreChange = (event) => {
    let value = event.target.value;
  
    // Allow only numbers with up to 2 digits and an optional single decimal place
    const validPattern = /^(?:\d{1,2}(?:\.\d)?)?$/;
  
    if (validPattern.test(value)) {
      setProgressValuePre(parseFloat(value) || ""); // Ensure empty input doesn't become NaN
    
       
    }

      if(parseFloat(value) <= 12 && parseFloat(value) != 1){
         setProgressValuePost(parseFloat(value) - 2);
      }
  };
  const handlePreInflationBlur =(event)=>{
    const value = Math.round((event.target.value) * 2) / 2;
    setProgressValuePre(value)
    if (value < 6) {
      setProgressValuePre(6);
      setProgressValuePost(4);
     
    } else if (value > 15) {
      setProgressValuePre(15);
    
     
    }

    if(value >= 15){
      setProgressValuePost(10);
    }


  }
  const handleProgressPostChange = (event) => {
    let value = event.target.value;
  
    // Allow only numbers with up to 2 digits and an optional single decimal place
    const validPattern = /^(?:\d{1,2}(?:\.\d)?)?$/;
  
    if (validPattern.test(value)) {
      setProgressValuePost(parseFloat(value) || ""); // Ensure empty input doesn't become NaN
    }
  };
  const handlePostInflationBlur =(event)=>{
    const value = Math.round((event.target.value) * 2) / 2;
    setProgressValuePost(value);
    if (value < inflationRateClientDetails) {
      //setProgressValuePost(inflationRateClientDetails);
     
    } else if (value > 10) {
      setProgressValuePost(10);
     
    }
  }
//pdf download
  const donwloadPDF = async (url) => {
    //console.log('download pdf function called')
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank"
    link.download = `${plan_id}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    //console.log("pdfUrl", url);

  }
    //epf
    const handleEpfHolding = (event) => {
      let inputValue = event.target.value.replace(/,/g, "");      
      // Allow empty input for backspacing
      if (inputValue === "") {
        setEpfHolding("");
        setNumericEpfHolding(null);
      }
      
      // Prevent leading zero
      if (inputValue.length > 1 && inputValue[0] === "0") {
          return;
      }
      
      // Allow only numeric input
      if (!/^[1-9][0-9]*$/.test(inputValue)) {
          return; // Stop execution if input is not a number or starts with 0
      }
    
      // Restrict maximum value to 10 crores (100000000)
      if (Number(inputValue) > 1000000000) {
          return;
      }
    
      const numericValue = Number(inputValue);
      const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
    
      // Set both formatted and numeric values
      setEpfHolding(formattedValue);
      setNumericEpfHolding(numericValue);
  };
  const handleEpfContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setEpfContribution("");
      setNumericEpfContribution(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setEpfContribution(formattedValue);
    setNumericEpfContribution(numericValue);
    
  }
  // nps
  const handleNpsHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setNpsHolding("");
      setNumericNpsHolding(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setNpsHolding(formattedValue);
    setNumericNpsHolding(numericValue);
    

  }
  const handleNpsContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setNpsContribution("");
      setNumericNpsContribution(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setNpsContribution(formattedValue);
    setNumericNpsContribution(numericValue);
    
  }
  // mf
  const handleMfHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setMfHolding("");
      setNumericMfHolding(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setMfHolding(formattedValue);
    setNumericMfHolding(numericValue);
    

  }
  const handleMfContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setMfContribution("");
      setNumericMfContribution(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setMfContribution(formattedValue);
    setNumericMfContribution(numericValue);
    
  }
  //bonds
  const handleBondsHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setBondsHolding("");
      setNumericBondsHolding(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setBondsHolding(formattedValue);
    setNumericBondsHolding(numericValue);
    

  }
  const handleBondsContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setBondsContribution("");
      setNumericBondsContribution(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setBondsContribution(formattedValue);
    setNumericBondsContribution(numericValue);
    
  }
  //nonRet
  const handleNonRetHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setNonRetHolding("");
      setNumericNonRetHolding(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setNonRetHolding(formattedValue);
    setNumericNonRetHolding(numericValue);
    

  }
  const handleNonRetContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setNonRetContribution("");
      setNumericNonRetContribution(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setNonRetContribution(formattedValue);
    setNumericNonRetContribution(numericValue);
    
  }
  //ppf
  const handlePpfHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setPpfHolding("");
      setNumericPpfHolding(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setPpfHolding(formattedValue);
    setNumericPpfHolding(numericValue);
    

  }
  const handlePpfContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setPpfContribution("");
      setNumericPpfContribution(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setPpfContribution(formattedValue);
    setNumericPpfContribution(numericValue);
    
  }

  //ret
  const handleRetHolding = (event) => {
     let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setRetHolding("");
      setNumericRetHolding(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setRetHolding(formattedValue);
    setNumericRetHolding(numericValue);
    

  }
  const handleRetContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setRetContribution("");
      setNumericRetContribution(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setRetContribution(formattedValue);
    setNumericRetContribution(numericValue);
    
  }
  //stocks
  const handleStocksHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setStocksHolding("");
      setNumericStocksHolding(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setStocksHolding(formattedValue);
    setNumericStocksHolding(numericValue);
    

  }
  const handleStocksContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setStocksContribution("");
      setNumericStocksContribution(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setStocksContribution(formattedValue);
    setNumericStocksContribution(numericValue);
    
  }
  //fd
  const handleFdHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setFdHolding("");
      setNumericFdHolding(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setFdHolding(formattedValue);
    setNumericFdHolding(numericValue);
    

  }
  const handleFdContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");      
    // Allow empty input for backspacing
    if (inputValue === "") {
      setFdContribution("");
      setNumericFdContribution(null);
    }
    
    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
        return;
    }
    
    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
        return; // Stop execution if input is not a number or starts with 0
    }
  
    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
        return;
    }
  
    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);
  
    // Set both formatted and numeric values
    setFdContribution(formattedValue);
    setNumericFdContribution(numericValue);
    
  }

  const getPdfURL = async () => {
    let returnObj = null;
    try {
      setShowModal(true);
      const result = await prpHttpAPI(pdfData, 'get-pdf/pdf', null, "POST")
      if (result.success) {
        returnObj = result;
        setUrl(result.url)

      }
    } catch (error) {
      console.log("There is some error after api fetch", error.message);
    }

    return returnObj

  }

  const handlePreparePlan = async () => {
    // Create the data you want to encrypt
    try {
      setLoading(true);
      const userData = {
        plan_id: plan_id,
        epf_holding: stringToNum(epfHolding),
        epf_monthly: stringToNum(epfContribution),
        ppf_holding: stringToNum(ppfHolding),
        ppf_monthly: stringToNum(ppfContribution),
        nps_holding: stringToNum(npsHolding),
        nps_monthly: stringToNum(npsContribution),
        other_retirement_investment_holding: stringToNum(retHolding),
        other_retirement_investment_monthly: stringToNum(retContribution),
        mf_holding: stringToNum(mfHolding),
        mf_monthly: stringToNum(mfContribution),
        stocks_holding: stringToNum(stocksHolding),
        bonds_holding: stringToNum(bondsHolding),
        fdrd_holding: stringToNum(fdHolding),
        fdrd_monthly: stringToNum(fdContribution),
        other_non_retirement_investment_holding: stringToNum(nonRetHolding),
        other_non_retirement_investment_monthly: stringToNum(nonRetContribution),
        post_ret_ror: (progressValuePost),
        pre_ret_ror: (progressValuePre),
        total_holding:stringToNum(totalHolding),
        total_monthly:stringToNum(totalContribution)
      }
      localStorage.setItem('clientInvestmentData', JSON.stringify(userData));
      localStorage.setItem('versions', processString(localStorage.getItem('plan_id')));
      setData(userData)
      console.log(userData);
      const localtoken = localStorage.getItem("ssotoken");
      const result = await prpHttpAPI(userData, 'client-investment-details',localtoken, "POST")
      if (result.success) {

        console.log("client-investment-details Response:  ", result);
        navigate('/plan-output',  { state: { from: "clientInvestment" } })
        // let pdfResult = await getPdfURL();
        // console.log("get-pdf/pdf Response:  ", pdfResult);

        // if (!pdfResult.success) {
        //   console.log('pdf url is empty');
        //   return;

        // }
        // else {
        //   setLoading(false);
        //   donwloadPDF(pdfResult.url);
        //   setDownloadFlag(true);
         
        // }
      }
    } catch (error) {
      console.log("There is some error after api fetch ", error.message);
    }

  }
  const handleBack = () => {
    const clientInvestmentData = {
      plan_id: plan_id,
      epf_holding: stringToNum(epfHolding),
      epf_monthly: stringToNum(epfContribution),
      ppf_holding: stringToNum(ppfHolding),
      ppf_monthly: stringToNum(ppfContribution),
      nps_holding: stringToNum(npsHolding),
      nps_monthly: stringToNum(npsContribution),
      other_retirement_investment_holding: stringToNum(retHolding),
      other_retirement_investment_monthly: stringToNum(retContribution),
      mf_holding: stringToNum(mfHolding),
      mf_monthly: stringToNum(mfContribution),
      stocks_holding: stringToNum(stocksHolding),
      bonds_holding: stringToNum(bondsHolding),
      fdrd_holding: stringToNum(fdHolding),
      fdrd_monthly: stringToNum(fdContribution),
      other_non_retirement_investment_holding: stringToNum(nonRetHolding),
      other_non_retirement_investment_monthly: stringToNum(nonRetContribution),
      post_ret_ror: (progressValuePost),
      pre_ret_ror: (progressValuePre),
      total_holding:stringToNum(totalHolding),
      total_monthly:stringToNum(totalContribution)
    }
    localStorage.setItem('clientInvestmentData', JSON.stringify(clientInvestmentData));
    navigate('/client-details')
  }
  return (
    <>
      <div className={styles.topMain}>
        <div className={styles.main}>
          <div><p className={`${styles.heading}`}>Enter <span className={styles.highlighted}>Client Investments</span> </p></div>
          <div className={styles.mainDiv}>
            <div className={styles.leftDiv} >
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> EPF
                  <div className={styles.inputGroup}>
                    <div className={styles.inputDiv}>
                      {epfHolding && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={epfHolding} onChange={handleEpfHolding} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {epfHolding && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={styles.inputDiv}>
                      {epfContribution && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={epfContribution} onChange={handleEpfContribution} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {epfContribution && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> NPS
                  <div className={styles.inputGroup}>
                    <div className={styles.inputDiv}>
                      {npsHolding && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={npsHolding} onChange={handleNpsHolding} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {npsHolding && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={styles.inputDiv}>
                      {npsContribution && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={npsContribution} onChange={handleNpsContribution} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {npsContribution && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> Mutual Funds
                  <div className={styles.inputGroup}>
                    <div className={styles.inputDiv}>
                      {mfHolding && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={mfHolding} onChange={handleMfHolding} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {mfHolding && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={styles.inputDiv}>
                      {mfContribution && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={mfContribution} onChange={handleMfContribution} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {mfContribution && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> Bonds
                  <div className={styles.inputGroup}>
                    <div className={styles.inputDiv}>
                      {bondsHolding && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={bondsHolding} onChange={handleBondsHolding} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {bondsHolding && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={styles.inputDiv}>
                      {bondsContribution && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={bondsContribution} disabled onChange={handleBondsContribution} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {bondsContribution && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> Other Non-Retirement Investments
                  <div className={styles.inputGroup}>
                    <div className={styles.inputDiv}>
                      {nonRetHolding && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={nonRetHolding} onChange={handleNonRetHolding} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {nonRetHolding && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={styles.inputDiv}>
                      {nonRetContribution && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={nonRetContribution} onChange={handleNonRetContribution} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {nonRetContribution && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div>
                <div className={styles.progressText}>
                  <label className={styles.labelField}>Return rate on investments in pre-retirement
                    <br></br>period
                  </label>
                  <div className={styles.inflationDiv}>
                    <input value={progressValuePre} onChange={handleProgressPreChange} onBlur={handlePreInflationBlur} type="number" step={0.5} min={6} max={15} className={styles.inflationRate}></input>
                    <span className={styles.inflationSpan}>%</span>
                  </div>
                </div>
                <div >
                  <input
                    className={styles.inputField}
                    type="range"
                    min="6"
                    max="15"
                    step="0.5"
                    value={progressValuePre}
                    onChange={handleProgressPreChange}
                  />


                </div>
                <div className={styles.progressLimit}>
                  <span>6%</span>
                  <span>15%</span>
                </div>
              </div>
            </div>
            <div className={styles.rightDiv}>
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> PPF
                  <div className={styles.inputGroup}>
                    <div className={styles.inputDiv}>
                      {ppfHolding && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={ppfHolding} onChange={handlePpfHolding} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {ppfHolding && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={styles.inputDiv}>
                      {ppfContribution && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={ppfContribution} onChange={handlePpfContribution} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {ppfContribution && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> Other Retirement Investments
                  <div className={styles.inputGroup}>
                    <div className={styles.inputDiv}>
                      {retHolding && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={retHolding} onChange={handleRetHolding} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {retHolding && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={styles.inputDiv}>
                      {retContribution && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={retContribution} onChange={handleRetContribution} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {retContribution && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> Stocks
                  <div className={styles.inputGroup}>
                    <div className={styles.inputDiv}>
                      {stocksHolding && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={stocksHolding} onChange={handleStocksHolding} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {stocksHolding && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={styles.inputDiv}>
                      {stocksContribution && <span className={styles.inputSpanBefore}>₹</span>}
                      <input disabled value={stocksContribution} onChange={handleStocksContribution} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {stocksContribution && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> Fixed Deposits & Recurring Deposits
                  <div className={styles.inputGroup}>
                    <div className={styles.inputDiv}>
                      {fdHolding && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={fdHolding} onChange={handleFdHolding} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {fdHolding && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={styles.inputDiv}>
                      {fdContribution && <span className={styles.inputSpanBefore}>₹</span>}
                      <input value={fdContribution} onChange={handleFdContribution} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {fdContribution && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div className={styles.labelGroup}>
                <label htmlFor="" className={styles.labelField}> Total
                  <div className={styles.inputGroup}>
                    <div className={`${styles.inputDiv} ${styles.disabledGroup}`}>
                      {totalHolding !== null && <span className={styles.inputSpanBefore}>₹</span>}
                      <input disabled value={totalHolding ||""} type="text" placeholder='Current Holding' className={styles.inputField} />
                      {totalHolding !== null && <span className={styles.inputSpanAfter}>Holding</span>}
                    </div>
                    <div className={`${styles.inputDiv} ${styles.disabledGroup}`}>
                      {totalContribution !== null && <span className={styles.inputSpanBefore}>₹</span>}
                      <input disabled value={totalContribution || ""} type="text" placeholder='Monthly Contribution' className={styles.inputField} />
                      {totalContribution !== null && <span className={styles.inputSpanAfter}>Monthly</span>}
                    </div>
                  </div>
                </label>
              </div>
              <div>
                <div className={styles.progressText}>
                  <label className={styles.labelField}>Return rate on investments in post-retirement
                    <br></br>period
                  </label>
                  <div className={styles.inflationDiv}>
                    <input value={progressValuePost} onChange={handleProgressPostChange} onBlur={handlePostInflationBlur}  type="number" step={0.5} min={4} max={10} className={styles.inflationRate}></input>
                    <span className={styles.inflationSpan}>%</span>
                  </div>

                </div>
                <div >

                  <input
                    className={styles.inputField}
                    type="range"
                    min="4"
                    max="10"
                    step="0.5"
                    value={progressValuePost}
                    onChange={handleProgressPostChange}
                    

                  />

                </div>
                <div className={styles.progressLimit}>
                  <span>{4}%</span>
                  <span>10%</span>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.loaderGroup}>
          <div className={styles.btnGroup}>
            <button onClick={handleBack} className={` btn  ${styles.backBtn}`}>Back</button>
            <button onClick={handlePreparePlan} className={` btn  ${styles.nextBtn}`}>Prepare Plan</button>
          </div>
          {loading && 
                  <div className={` spinner-border text-danger ${styles.loaderDiv}`} role="status">
                  <span className="sr-only"></span>
                  </div>}
          </div>
        </div>
        {/* MODAL */}
        {/* { showModal && <Modal setShowModal={setShowModal} flag={downloadFlag} loading={loading} name={localStorage.getItem("client_name")} />} */}

      </div>
    </>
  )
}
